import { AxiosService } from './';

const getFiatTransactionList = async (
  _perPage,
  _page,
  commonSearch,
  sortBy,
  user_id = null,
  _status,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/fiat_transactions',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        sortBy: sortBy,
        user_id: user_id,
        status: _status,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getOnchainTransactionList = async (
  _perPage,
  _page,
  commonSearch,
  sortBy,
  user_id,
  _type,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/onchain_transactions',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: commonSearch,
        sortBy: sortBy,
        user_id: user_id,
        type: _type,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export { getFiatTransactionList, getOnchainTransactionList };
